<h1 mat-dialog-title class="w-100"><i class="fa-solid fa-book"></i> Wprowadź adresy firmowe</h1>
<form [formGroup]="formAdress">
	<mat-dialog-content class="mat-typography" class="w-100">
		<mat-form-field class="w-100">
			<input matInput type="text" placeholder="Adres" formControlName="address" />
		</mat-form-field>
		<mat-form-field class="w-100">
			<input matInput type="text" placeholder="Kod pocztowy" formControlName="zipCode" />
		</mat-form-field>
		<div class="w-100">
			<ng-select placeholder="Miasto" formControlName="location">
				@for (location of service.enterpriseData.locations; track location.id) {
					<ng-option [value]="location">
						{{ location.name }}
						<small>({{ location.parentLocation?.name }})</small>
					</ng-option>
				}
			</ng-select>
		</div>
		<mat-form-field class="w-100">
			<mat-select placeholder="Typ" formControlName="type">
				@for (item of service.enterpriseData.addressKind; track item.id) {
					<mat-option [value]="item.id"> {{ item.kind }}</mat-option>
				}
			</mat-select>
		</mat-form-field>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-raised-button color="warn" mat-dialog-close>Anuluj</button>
		<button mat-raised-button color="primary" cdkFocusInitial (click)="addAddress()">Dodaj adres</button>
	</mat-dialog-actions>
</form>
